import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HiddenInputItemComponent } from './hidden-input-item/hidden-input-item.component';
import { ModuleProgressItemComponent } from './module-progress-item/module-progress-item.component';

@NgModule({
  declarations: [HiddenInputItemComponent, ModuleProgressItemComponent],
  imports: [CommonModule, FormsModule, IonicModule],
  exports: [HiddenInputItemComponent, ModuleProgressItemComponent],
})
export class OnboardingCoreComponentsModule {}
